import { badgeColorMap } from '@/utilities/badgeColorMap'
import { kebabToCamel } from '@/utilities/toCamel'
import { cn } from '@/utilities/ui'

const Pill = ({
  children,
  color,
  size = 'default',
  bold = false,
  className,
  ...props
}: {
  children: React.ReactNode
  color: string
  size?: 'default' | 'small'
  bold?: boolean
} & React.ComponentProps<'div'>) => {
  const topicColor = kebabToCamel(color)
  const topicColorObject = badgeColorMap[topicColor]

  return (
    <div
      className={cn(
        'flex shrink-0 items-center rounded-full border text-sm font-medium',
        size === 'default' ? 'gap-2 px-3 py-1 leading-5' : 'gap-1 px-2 py-1 leading-4',
        bold && 'font-bold',
        topicColorObject.bg,
        topicColorObject.text,
        topicColorObject.border,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export default Pill
